import http from '../Http';
import { useEffect, useState, useContext, useRef } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Image } from 'antd';
import { useTranslation } from 'react-i18next';

function InverterManufacturerModify (props) {
    const setTip = useContext(utils.tipContext);
    const { t } = useTranslation();

    const {show, onClose, row} = props;

    const [form] = Form.useForm();

    const imageFile = useRef(null);

    const [imageBase64, setImageBase] = useState(row.Image);

    const handleCancle = () => {
        onClose(null);
    }

    const handleImageFileChange = async () => {
        const base64 =  await new Promise((resolve, reject) => {
            const reader = new FileReader();
            const tmr = setTimeout(() => {
                reject(null);
            }, 500);
            reader.addEventListener('load', () => {
                clearTimeout(tmr);

                resolve(reader.result);
            });
            reader.readAsDataURL(imageFile.current.input.files.item(0));
        }).catch((e) => {
            console.log("[InverterManufacturerAdd]", e);
        });

        setImageBase(base64 || "");
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => {return null});
        
        if (ps === null) {
            return;
        }
        ps["ID"] = row.ID;
        
        ps.ImageBase64 = (imageBase64 || "").replace(/;/g, "；").replace(/\+/g, "＋");

        const resp = await http.post("inverter-manufacturer/modify", ps).then(async (r)=>{
            return await r.json();
        }).catch((e) => {
            console.log("[InverterManufacturerModify]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("modify_error")});
                return
            }

            setTip({open: true, severity: 'success', msg: t('modify_success')});

            ps.Image = ps.ImageBase64.replace(/；/g, ";").replace(/＋/g, "+")
            onClose(ps);
        } catch (e) {
            console.log("[InverterManufacturerModify]", e);

            setTip({open:true, severity:"error", msg: t("modify_error")});
        }
    }

    const params = {...row};

    return (<Modal 
        title={t("Modify Inverter Manufacturer")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={700}
        onCancel={handleCancle}
        onOk={handleSubmit}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 9 }}
            wrapperCol={{ span: 14 }}
            form={form}
            initialValues={params}
        >
            <Form.Item 
                name="Name"
                label={t("Name")}
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>
            <Form.Item 
                name="Image"
                label={t("Image")}
            >
                <label htmlFor="_image" style={{cursor:"pointer"}}>{t("Choose images (PNG, JPG)")}</label>
                <Input ref={imageFile} onChange={handleImageFileChange} id="_image" type='file' accept=".png,.jpg,.jpeg" style={{opacity:0}} />
                <Image height={40} src={imageBase64}/>
            </Form.Item>
        </Form>
    </Modal>)
}

export default InverterManufacturerModify;